import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheck, TrendingUp } from 'lucide-react';
import { EASE_OUT, SPRING } from 'shared/components/motion/tokens';

const COURTS = [
  { name: 'Quadra Central', occupancy: 86 },
  { name: 'Quadra Pôr do Sol', occupancy: 72 },
  { name: 'Quadra Coberta', occupancy: 64 },
];

const SLOTS = [
  { time: '17:00', label: 'Aula · Turma B', tone: 'bg-accent-soft text-primary-dark' },
  { time: '18:00', label: 'Reserva · Diego C.', tone: 'bg-success-soft text-success' },
  { time: '19:00', label: 'Racha nível B · 3/4', tone: 'bg-warning-soft text-warning' },
];

// Vitrine do painel do dono de arena no cadastro: mostra o produto em vez de listar benefícios.
// Decorativa (aria-hidden) — o título ao lado já descreve o que ela ilustra.
export function ArenaPanelPreview() {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setShowNotification(true), 1600);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div aria-hidden="true" className="relative w-full max-w-md select-none pb-10 pt-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE_OUT, delay: 0.2 }}
        className="rounded-2xl border border-white/10 bg-surface p-5 text-ink shadow-2xl"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-ink-secondary">Arena Sol Nascente</p>
            <p className="font-heading text-base font-bold">Agenda de hoje</p>
          </div>
          <span className="rounded-full bg-success-soft px-2.5 py-1 text-xs font-semibold text-success">
            Ao vivo
          </span>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-3">
          <div className="rounded-xl bg-background p-3">
            <p className="text-[11px] font-medium uppercase tracking-wide text-ink-secondary">Receita do dia</p>
            <p className="mt-0.5 font-heading text-lg font-bold">R$ 3.640</p>
          </div>
          <div className="rounded-xl bg-background p-3">
            <p className="text-[11px] font-medium uppercase tracking-wide text-ink-secondary">Ocupação</p>
            <p className="mt-0.5 flex items-center gap-1.5 font-heading text-lg font-bold">
              78%
              <span className="flex items-center text-xs font-semibold text-success">
                <TrendingUp className="h-3.5 w-3.5" />6%
              </span>
            </p>
          </div>
        </div>

        <div className="mt-4 flex flex-col gap-2.5">
          {COURTS.map((court, index) => (
            <div key={court.name}>
              <div className="mb-1 flex justify-between text-xs">
                <span className="font-medium">{court.name}</span>
                <span className="text-ink-secondary">{court.occupancy}%</span>
              </div>
              <div className="h-1.5 overflow-hidden rounded-full bg-chip">
                <motion.div
                  className="h-full rounded-full bg-primary"
                  initial={{ width: 0 }}
                  animate={{ width: `${court.occupancy}%` }}
                  transition={{ duration: 0.9, ease: EASE_OUT, delay: 0.5 + index * 0.12 }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 flex flex-col gap-1.5 border-t border-border/60 pt-4">
          {SLOTS.map((slot) => (
            <div key={slot.time} className="flex items-center gap-3 text-xs">
              <span className="w-10 text-ink-secondary">{slot.time}</span>
              <span className={`flex-1 rounded-md px-2 py-1 font-medium ${slot.tone}`}>{slot.label}</span>
            </div>
          ))}
        </div>
      </motion.div>

      <AnimatePresence>
        {showNotification && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.92 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={SPRING}
            className="absolute -right-6 top-0 flex items-center gap-2.5 rounded-xl bg-surface px-3.5 py-2.5 text-sm text-ink shadow-2xl"
          >
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-success-soft text-success">
              <BadgeCheck className="h-4 w-4" />
            </span>
            <span>
              <span className="block font-semibold">Reserva confirmada</span>
              <span className="text-xs text-ink-secondary">Pix dividido · 4 de 4 pagos</span>
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
